import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { Flip } from "gsap/Flip";

gsap.registerPlugin(ScrollTrigger, SplitText, Flip);

export default gsap;

export {
    gsap,
    ScrollTrigger,
    SplitText,
    Flip,
};

export function useGSAP() {
    return {
        gsap,
        SplitText,
        ScrollTrigger,
        Flip,
    }
}
